import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function CompanyList() {
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();

  const fetchCompanies = async () => {
    try {
      const res = await API.get('/companies');
      setCompanies(Array.isArray(res.data) ? res.data : res.data.companies || []);
    } catch (err) {
      console.error(err);
      alert('Failed to fetch companies');
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this company?')) return;
    try {
      await API.delete(`/companies/${id}`);
      fetchCompanies();
    } catch {
      alert('Failed to delete company');
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 'active' ? 'closed' : 'active';
      await API.patch(`/companies/${id}/status`, { status: newStatus });
      fetchCompanies();
    } catch {
      alert('Failed to update status');
    }
  };

  const handleToggleNotification = async (company_id, field, currentValue) => {
    try {
      const newValue = currentValue === 'true' ? 'false' : 'true';
      await API.patch(`/superadmin/companies/${company_id}/update-notification-status`, {
        [field]: newValue
      });
      fetchCompanies();
    } catch (err) {
      console.error(err);
      alert(`Failed to update ${field}`);
    }
  };

  const toggleTopPerformance = async (company_id, currentStatus) => {
    try {
      const newValue = currentStatus === 'yes' ? 'no' : 'yes';
      await API.put(`/admin/top-performing-company/${company_id}`, {
        top_performing_company: newValue
      });
      fetchCompanies();
    } catch (err) {
      console.error(err);
      alert('Failed to update top performing status');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Company List</h2>
      <button onClick={() => navigate('/companies/create')}>+ Create Company</button>

      <table border="1" cellPadding="10" style={{ marginTop: 20, width: '100%' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>SMS</th>
            <th>Email</th>
            <th>Top Performance</th>
            <th>Actions</th>
            <th>Assign Devices</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((c) => (
            <tr key={c.company_id}>
              <td>{c.company_id}</td>
              <td>{c.company_name}</td>
              <td>{c.company_email}</td>
              <td>
                <button onClick={() => toggleStatus(c.company_id, c.company_status)}>
                  {c.company_status}
                </button>
              </td>
              <td>
                <button
                  onClick={() => handleToggleNotification(c.company_id, 'sms_status', c.sms_status)}
                  style={{
                    backgroundColor: c.sms_status === 'true' ? 'green' : 'gray',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px'
                  }}
                >
                  {c.sms_status === 'true' ? 'ON' : 'OFF'}
                </button>
              </td>
              <td>
                <button
                  onClick={() => handleToggleNotification(c.company_id, 'email_status', c.email_status)}
                  style={{
                    backgroundColor: c.email_status === 'true' ? 'green' : 'gray',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px'
                  }}
                >
                  {c.email_status === 'true' ? 'ON' : 'OFF'}
                </button>
              </td>
              <td>
                <button
                  onClick={() => toggleTopPerformance(c.company_id, c.top_performing_company)}
                  style={{
                    backgroundColor: c.top_performing_company === 'yes' ? '#00b894' : '#b2bec3',
                    color: 'white',
                    padding: '5px 10px',
                    border: 'none',
                    borderRadius: '5px'
                  }}
                >
                  {c.top_performing_company === 'yes' ? 'YES' : 'NO'}
                </button>
              </td>
              <td>
                <button onClick={() => navigate(`/companies/edit/${c.company_id}`)}>Edit</button>
                <button onClick={() => handleDelete(c.company_id)}>Delete</button>
              </td>
              <td>
                <button onClick={() => navigate(`/companies/${c.company_id}/assign-devices`)}>
                  Assign Devices
                </button>
                &nbsp;
                <button onClick={() => navigate(`/companies/${c.company_id}/view-devices`)}>
                  View Devices
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
